/* src/app/components/device-characteristics/device-characteristics.component.scss */
/*# sourceMappingURL=device-characteristics.component.css.map */
